import { createFileRoute } from '@tanstack/react-router'
import { UserProfilePage } from '../../../../components/UserProfilePage'
import { useAuth } from '../../../../hooks/useAuth'

export const Route = createFileRoute('/$org/users/me/settings')({
    component: UserProfileRoute,
})

function UserProfileRoute() {
    const { org } = Route.useParams()
    const { user } = useAuth()
    
    // Pass the current user's UID explicitly to behave exactly like /$userUid/settings
    return <UserProfilePage orgCode={org} userUid={user?.uid} />
}